exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.container4 {\r\n    height: 10em;\r\n    position: relative }\r\ndiv.container4 h1 {\r\n    margin: 0;\r\n    background: yellow;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    margin-right: -50%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n            transform: translate(-50%, -50%) }\r\n\r\n.text-inside-grid {\r\n    position: absolute;\r\n    left: 5px;\r\n    }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// c:/Dev/Angular/liceo/src/app/teacher-lack-report/teacher-lack-report.component.css
// module id = ../../../../../src/app/teacher-lack-report/teacher-lack-report.component.css
// module chunks = main